<div class="cancelled-container">
  <div class="cancelled-card">
    <div class="x-mark">✕</div>
    <h1>Payment Cancelled</h1>
    <p>Your transaction was not completed. No charge was made.</p>
    <button class="back-button" (click)="goBack()">Go Back</button>
  </div>
</div>